import { fromJS } from 'immutable';
import * as actionTypes from "./actionTypes";

const initialState = fromJS({
  zipCodes: {}
});

const reducer = (state = initialState, action) => {
  const zipCodes = state.getIn(['zipCodes']).toJS();
  const key = action.zipTitle;
  switch (action.type) {
    case actionTypes.zipcodeDataLoadingType:
      if (zipCodes.hasOwnProperty(key)) {
        zipCodes[key].loading = true;
        zipCodes[key].zip = null;
        zipCodes[key].city = null;
        zipCodes[key].state = null;
        zipCodes[key].country = null;
      } else {
        Object.defineProperty(zipCodes, key, {
          value: {
            loading: true,
            zip: null,
            city: null,
            state: null,
            country: null
          },
          writable: true,
          enumerable: true
        });
      }
      return state.setIn(['zipCodes'], fromJS(zipCodes));

    case actionTypes.zipcodeDataType:
      zipCodes[key].loading = false;
      zipCodes[key].zip = action.payload.zipCode;
      zipCodes[key].city = action.payload.city;
      zipCodes[key].state = action.payload.state;
      zipCodes[key].country = action.payload.country;
      return state.setIn(['zipCodes'], fromJS(zipCodes));

    case actionTypes.resetZipCodeDataType:
      const field = action.field;
      if (Object.keys(zipCodes).length) {
        zipCodes[key][field] = null;
        return state.setIn(['zipCodes'], fromJS(zipCodes));
      }
      return state;

    case actionTypes.resetAllZipFielsType:
      if (zipCodes && zipCodes[key]) {
        zipCodes[key].loading = false;
        zipCodes[key].zip = null;
        zipCodes[key].city = null;
        zipCodes[key].state = null;
        zipCodes[key].country = null;
      }
      return state.setIn(['zipCodes'], fromJS(zipCodes));

    case actionTypes.flushZipcodeFieldType:
      return state.setIn(['zipCodes'], fromJS({}));
      
    default:
      return state;
  }
};

export default reducer;
